module.exports = __webpack_public_path__ + "img/47.b6848455.jpg";